module.exports = __webpack_public_path__ + "e78cbf6b.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_microphone.png
// module id = 1197
// module chunks = 0 1 2